import devKeys from './dev';
import prodKeys from './prod';

export default function() {
    if(process.env.NODE_ENV === "development") {
        return devKeys;
    } else if(process.env.NODE_ENV === "production") {
        return prodKeys;
    }
}